import { render } from "./OrderListPage.vue?vue&type=template&id=69a59796"
import script from "./OrderListPage.vue?vue&type=script&lang=js"
export * from "./OrderListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__